/**
 * HELPER 
 * EnrolleeHelper 
 * @method getById 
 * @method getOriById 
 * @method getPermissionValueById
*/
var EnrolleeHelper = (function () {
    // var builder = new SumoPredicateBuilder();
    function EnrolleeHelperInstance(){
        this.builder = new SumoPredicateBuilder();
    }
    /**
     * This method will get a list of Agents filtered by OrganizationId 
     * @param  {} lOrganizationId
     */
    EnrolleeHelperInstance.prototype.getByOrganizationId = function(lOrganizationId,lFilterBy,lSortBy){
        this.builder.Clear();
        if(!lOrganizationId) throw 'Missing lOrganizationId in EnrolleeHelper method call';
        if(lOrganizationId){
            this.builder.AddNewExpressionConditional('OrganizationId', lOrganizationId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

        }
        this.builder.AddNewExpressionConditional('EnrolleeType', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        if(lFilterBy){
            if(!lFilterBy.hasOwnProperty("name") || !lFilterBy.hasOwnProperty("value")){
                throw "If using FilterBy option please include an object including name & value keys";
            }
            this.builder.AddNewExpressionConditional(lFilterBy.name, lFilterBy.value, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        }
        // this.builder.AddNewExpressionConditional('UserId', gUserDetails.UserId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        var lOffenders = query( getDataItems('Enrollees') ,this.builder.RootExpression);
        return lSortBy?SortBy(lOffenders,lSortBy): lOffenders;
    };
    /**
     * This Method will retrieve the Agent List filter by a Given Attribute  
     * @param  {} aAttribute
     * @param  {} aValue
     * e.g. 
     * var agents= AgentHelper.getBy('OrganizationId',1234); 
     */
    EnrolleeHelperInstance.prototype.getBy = function(aAttribute,aValue){
        this.builder.Clear();
        this.builder.AddNewExpressionConditional(aAttribute, aValue, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        return query(getDataItems('Enrollees'), this.builder.RootExpression);
    };
    function SortBy(aData,aKey){
        "use strict";
        var lSort = new SortExpression(),
            lEnrollees = !isNullOrUndefined(aData)?aData:getDataItems('Enrollees');
        for (var key in lEnrollees) {
            if (lEnrollees.hasOwnProperty(key)) {
                lEnrollees[key][aKey] = lEnrollees[key][aKey].trim();
            }
        }
        lSort.addAscendingColumn(aKey);
        lEnrollees = lSort.sort(lEnrollees);
    
        return lEnrollees;
        
    }
    EnrolleeHelperInstance.prototype.getLocalTimeZoneGuess = function(aValue){
        this.builder.Clear();
        this.builder.AddNewExpressionConditional('TimeZoneName', moment.tz.guess(), false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        var lTimezone = query(getDataItems('TimeZone'), this.builder.RootExpression);
        var timezone = "";
        for(var lKey in lTimezone) {
            if (lTimezone.hasOwnProperty(lKey)) {
                if(aValue && !lTimezone[lKey].hasOwnProperty(aValue)){
                    throw "EnrolleeHelper: error in Value, please valid parameters:"+lTimezone[lKey];
                }
                timezone = lTimezone[lKey].hasOwnProperty(aValue)?lTimezone[lKey][aValue]:lTimezone[lKey].Id;
            }
        }
        return timezone;
    }
    EnrolleeHelperInstance.prototype.getEventsByRangeDate = function (aEnrolleeId, aStartDate,aEndDate) {
        this.builder.Clear();
        this.builder.AddNewExpressionConditional('EnrolleeId', aEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        this.builder.AddNewExpressionConditional('StartDateUTC', aStartDate, false, mRelationalOperatorEnum.GreaterThanOrEqual(), mLogicalOperatorEnum.And());
        this.builder.AddNewExpressionConditional('StartDateUTC', aEndDate, false, mRelationalOperatorEnum.LessThanOrEqual(), mLogicalOperatorEnum.And());
        this.builder.AddNewExpressionConditional('DisplayFlag', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        var lEvents = query(getDataItems('Events'), this.builder.RootExpression);
        return lEvents;
    };
     /**
     * This method will return True of False if Enrollee has Devices assigned from the given Product Id list.
     * @param  {} lEnrolleeId Enrollee Id
     * @param  {} lProductIds Array [integer] List of Products Ids to match with Enrollee assignment
     */
    EnrolleeHelperInstance.prototype.IsEnrolleeAssignedToDevice = function (lEnrolleeId, lProductIds) {
        var lDeviceAssignments = gCurrentDeviceAssignment[lEnrolleeId], lDeviceIds = [];
        if (!isNullOrUndefined(lDeviceAssignments)) {
            for (var lKey in lDeviceAssignments) {
                if (lDeviceAssignments.hasOwnProperty(lKey)) {
                    var lItem = lDeviceAssignments[lKey];
                    if (lProductIds.indexOf(lItem.ProductId) !== -1) {
                        lDeviceIds.push(lItem.ProductId);
                    }
                }
            }
        }
        return lDeviceIds.length != 0;
    };
    return new EnrolleeHelperInstance();
})();

if (typeof exports !== 'undefined') {
    module.exports = EnrolleeHelper;
}